export default "__VITE_ASSET__BSMvsG8M__"